import React, { ReactChild, useEffect, useState } from 'react';
import Header from './header';
import Sidebar from './sidebar';
import { useAppDispatch } from '../../redux/hooks';
import { signOut } from '../../redux/user';
import { useIdleTimer } from 'react-idle-timer';
import Swal from 'sweetalert2';

type Props = {
    children: ReactChild;
};

const Layout: React.FC<Props> = ({ children }) => {
    const timeout = 900000; // 15 Minutes session timeout
    const [isIdle, setIsIdle] = useState(false);
    const handleOnActive = () => setIsIdle(false);
    const handleOnIdle = () => setIsIdle(true);
    useIdleTimer({
            timeout,
            onActive: handleOnActive,
            onIdle: handleOnIdle,
        });
const dispatch = useAppDispatch();
    useEffect(() => {
        if (!isIdle) return;
        if (isIdle) {
            dispatch(signOut());
            Swal.close();
        }
    }, [isIdle, dispatch]);
    return (
        <div>
            <Header />
            <Sidebar />

            <section className="page-content">
            <div className='text-end me-3'>
                    <button onClick={() => dispatch(signOut())}>
                                        <i className="bi bi-box-arrow-right" />
                                        <span className='fs-14'>Log out</span>
                                    </button>
                </div>
                <div className="container-fluid">
                    <div className="company-page-container">{children}</div>
                </div>
            </section>
        </div>
    );
};

export default Layout;
